import type { DetrixSession } from '../../types';

/** Earliest / latest timestamps present in a session (session-relative ms). */
export function sessionTimeBounds(session: DetrixSession): { min: number; max: number; duration: number } {
  const {
    steps = [],
    actions = [],
    network = [],
    events = [],
    browserResources = [],
  } = session;

  const all: number[] = [
    ...steps.flatMap((s) => [s.timestampStart, s.timestampEnd]),
    ...actions.map((a) => a.timestamp),
    ...network.flatMap((n) => [n.timestamp, n.timestamp + n.timing.durationMs]),
    ...events.map((e) => e.timestamp),
    ...browserResources.flatMap((r) => [r.timestamp, r.timestamp + r.timing.durationMs]),
  ].filter((n) => Number.isFinite(n));

  if (all.length === 0) {
    return { min: 0, max: 1, duration: 1 };
  }
  const min = Math.min(...all);
  const max = Math.max(...all);
  return { min, max, duration: Math.max(1, max - min) };
}
